// react-router components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Images
import bgImage from "assets/images/shapes/waves-white.svg";

// Data
//import pricingData from "pages/Booking/sections/data/pricingData";

function BookingCTA() {
  return (
    <MKBox component="section" py={{ xs: 0, sm: 0 }}>
      <MKBox
        variant="gradient"
        bgColor="info"
        position="relative"
        borderRadius="xl"
        sx={{ overflow: "hidden" }}
      >
        <MKBox
          component="img"
          src={bgImage}
          alt="pattern"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          zIndex={1}
          opacity={0.2}
        />
        <Container sx={{ position: "relative", zIndex: 2, py: 12 }}>
          <Grid container item xs={12} md={7} justifyContent="center" mx="auto" textAlign="center">
            <MKTypography variant="h3" color="white">
              Ready for your perfect getaway?
            </MKTypography>
            <MKTypography variant="h3" color="white" mb={2}>
              Book directly and save.
            </MKTypography>
            <MKTypography variant="body2" color="white" mb={4}>
              Book direct for the best rates &middot; One time deposit to secure your dates
            </MKTypography>
            <MKBox width="100%" textAlign="center">
              <MKButton
                variant="gradient"
                color="dark"
                size="large"
                component={Link}
                to="/booking"
                sx={{ mb: 1 }}
              >
                <Icon sx={{ mr: 1 }}>calendar_month</Icon>
                Book Now
              </MKButton>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
    </MKBox>
  );
}

export default BookingCTA;
